import type { SpotlightProps } from '@atlaskit/onboarding/types';

export const heading = (value: SpotlightProps['heading']): SpotlightProps['heading'] => {
	return value;
};
